module.exports = __webpack_public_path__ + "static/media/strengths.c576e13d.png";